/**
 * Transform a locale to the RFC 4646 format.
 *
 * @see {@link https://www.rfc-editor.org/rfc/rfc4646 RFC 4646}
 */
export function toRfc4646Locale(locale: string) {
  const match = locale.match(
    /^(?<language>[a-zA-Z]{2}).(?<countryCode>[a-zA-Z]{2})$/,
  )

  if (!match?.groups) {
    return locale
  }

  const { language, countryCode } = match.groups

  if (!language || !countryCode) {
    return locale
  }

  return `${language.toLowerCase()}-${countryCode.toUpperCase()}`
}
